import { Component, Prop, getAssetPath, h } from '@stencil/core';

import { DynamicEntryInstallationMode } from '../../../utils/utils.dynamic-entry';
import { DynamicEntryWorkflow } from '../../../utils/utils.landing';
import { DEFAULT } from '../../../utils/utils.landing-oem';
import KbbicoLogo from '../../ui-common/svg/kbbico-logo/kbbico-logo';

@Component({
  tag: 'landing-oem',
  styleUrl: 'landing-oem.css',
  shadow: true,
})
export class LandingOem {
  @Prop() dynamicEntryWorkflow: DynamicEntryWorkflow = DynamicEntryWorkflow.OEM;
  @Prop() offerCode: string = '';
  @Prop() installationMode?: DynamicEntryInstallationMode;
  @Prop() tabList: string[] = DEFAULT.TAB_LIST;
  @Prop() heading: string = DEFAULT.HEADING;
  @Prop() subheading: string = DEFAULT.SUBHEADING;
  @Prop() mainImage: string = '';
  @Prop() legalContent: string = DEFAULT.LEGAL_CONTENT;
  @Prop() theme?: string = '';
  @Prop() vehicle: string;
  @Prop() inputVin: string = '';
  @Prop() mileage?: number;
  @Prop() imageUrl: string = '';
  @Prop() dealerId: string = '';
  @Prop() dealerGroupId: string = '';
  @Prop() cobrandingGroupId: string = '';

  render() {
    return (
      <div class={`${this.theme}-theme`}>
        <div class="landing-oem h-screen absolute" />
        <div class="grid md:grid-cols-12 gap-4 max-w-7xl mx-auto mt-5 lg:mt-24">
          <div class="col-span-full mdLrg:col-span-6 mx-auto lg:mx-0">
            <div class="w-40 landing-oem-logo-background landing-oem-logo-background--visibility">
              <KbbicoLogo />
            </div>

            <h1 class="landing-oem-heading-text text-5xl whitespace-pre-line mt-4" data-testid="ci-heading">
              {this.heading}
            </h1>
            <h2 class="landing-oem-sub-heading-text font-medium text-2xl my-4" data-testid="ci-sub-heading">
              {this.subheading}
            </h2>
            <ico-dynamic-entry-hydrator
              offerCode={this.offerCode}
              tabList={this.tabList}
              installationMode={this.installationMode}
              dynamicEntryWorkflow={this.dynamicEntryWorkflow}
              vehicle={this.vehicle}
              inputVin={this.inputVin}
              mileage={this.mileage}
              dealerId={this.dealerId}
              dealerGroupId={this.dealerGroupId}
              cobrandingGroupId={this.cobrandingGroupId}>
              <ico-dynamic-entry />
            </ico-dynamic-entry-hydrator>
            <div class="mt-5 max-w-540">
              <landing-legal testId="ci-legal-text" content={this.legalContent} fullSize></landing-legal>
            </div>
          </div>
          <div class="hidden mdLrg:block mdLrg:col-span-6 mt-10 mx-auto mdLrg:mx-0 self-end ">
            {this.imageUrl && <img src={getAssetPath(this.imageUrl)} alt="Kelley Blue Book" class="w-full max-w-540 mdLrg:max-w-1000 mx-auto" />}
          </div>
        </div>
      </div>
    );
  }
}
